import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'
import {useState, useRef, useMemo} from 'react'

import {defaultHour, defaultMinute, timeZoneList} from './JobTriggerForm.consts'
import type {JobTriggerOnApplyChange} from './JobTriggerForm.types'

function useJobTriggerForm(
  onApply: JobTriggerOnApplyChange,
  daysOfWeek: string[],
  timeZone?: string,
) {
  const inputTimeRef = useRef<HTMLInputElement>(null)
  const defaultTimeZone = useMemo(() => timeZoneList.find(({key}) => key === timeZone), [timeZone])
  const [selectedDaysOfWeek, setSelectedDaysOfWeek] = useState<SelectItem[]>(() =>
    daysOfWeek.map(day => ({key: day, label: day})),
  )
  const [timeZoneSelected, setTimeZoneSelected] = useState<SelectItem>(defaultTimeZone!)
  const handlerDayChange = (value: SelectItem[] | null) => {
    setSelectedDaysOfWeek(value ?? [])
  }
  const handlerTimeZoneChange = (value: SelectItem | null) => setTimeZoneSelected(value!)
  const handlerApplyChangesClick = () => {
    const {value = ''} = inputTimeRef.current!
    const [hour = defaultHour, minute = defaultMinute] = value.split(':')

    onApply({
      timezone: timeZoneSelected.key.toString(),
      daysOfWeek: selectedDaysOfWeek.map(day => day.key).join(','),
      hour,
      minute,
    })
  }

  return {
    handlerTimeZoneChange,
    handlerDayChange,
    handlerApplyChangesClick,
    timeZoneSelected,
    inputTimeRef,
    selectedDaysOfWeek,
  }
}

export default useJobTriggerForm
